import { Add } from "@mui/icons-material";
import { Drawer, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import NavigationHeader from "./NavigationHeader";
import NavigationList from "./NavigationList";
import { NavigationContainer, NewOrderButton } from "./styles";
import { canExpertPlaceAndEditOrders } from "../user/accessRightChecks";
import { useAppSelector } from "../../app/hooks";

export const DRAWER_WIDTH = 256;

export const HomeDrawer = () => {
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.user.user);

  return (
    <Drawer
      data-testid="home-drawer-root"
      variant="permanent"
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: DRAWER_WIDTH,
          boxSizing: "border-box",
        },
      }}
    >
      <NavigationContainer data-testid="home-drawer-navigation-container">
        <NavigationHeader />
        {user && canExpertPlaceAndEditOrders(user) && (
          <Link to="/home/orders/new">
            <NewOrderButton
              data-testid="home-drawer-new-order-button"
              variant="contained"
              startIcon={<Add />}
            >
              {t("order:newOrder")}
            </NewOrderButton>
          </Link>
        )}
      </NavigationContainer>
      <NavigationList />
      <Typography
        data-testid="home-drawer-version-text"
        sx={{
          position: "absolute",
          left: 0,
          bottom: 0,
          margin: 2,
          fontSize: 14,
        }}
      >
        {t("version")} {process.env.REACT_APP_VERSION || ""}
      </Typography>
    </Drawer>
  );
};
